import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import CustomButton from "../common/CustomButton";
import CustomTextFeild from "../common/CustomTextFeild";
import Search from "../assets/images/search.png";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import {
  FaChartPie,
  FaUsers,
  FaThLarge,
  FaClipboardList,
  FaMapMarkerAlt,
} from "react-icons/fa";
import CustomModal from "../common/CustomModal";
import CustomSelect from "../common/CustomSelect";
import WhiteSearch from "../assets/images/whitesearch.png";
import { useSelector } from "react-redux";
import { getTheme } from "../redux/selectors/appSelectors";
import Pagination from "../common/Pagination";
import { _apiUrls } from "../utils/endpoints/apiUrls";
import { apiRequest } from "../utils/config/apiRequest";

export default function Reports() {
  const theme = useSelector(getTheme);
  const isDarkMode = theme === "dark";
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const [filters, setFilters] = useState({
    memberId: "",
    email: "",
    country: "",
    status: "",
  });
  const [state, setState] = useState({ rows: [] });
  const [totalItems, setTotalItems] = useState(0);

  const [filterModal, setFilterModal] = useState(false);

  const [activeTab, setActiveTab] = useState("push");

  const tabs = [
    {
      id: "push",
      label: "Push Notification Performance Report",
      icon: <FaChartPie />,
    },
    { id: "user", label: "User Activity Report", icon: <FaUsers /> },
    { id: "revenue", label: "Revenue & Package Report", icon: <FaThLarge /> },
    {
      id: "category",
      label: "Category Insights Report",
      icon: <FaClipboardList />,
    },
    // {
    //   id: "location",
    //   label: "Location Insights Report",
    //   icon: <FaMapMarkerAlt />,
    // },
  ];

  const fetchUsers = async () => {
    setLoading(true);

    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getUserReport,
      method: "GET",
      query: {
        search: searchText,
        page: currentPage,
        limit: itemsPerPage,
        ...filters,
      },
    });
    if (status) {
      setState({ ...state, rows: Array.isArray(data?.rows) ? data.rows : [] });
      setTotalItems(data?.count || 0);
    }
    setLoading(false);
  };

  const fetchPurchaseStats = async () => {
    setLoading(true);

    const { data, status } = await apiRequest({
      endUrl: _apiUrls.purchaseHistory,
      method: "GET",
      query: {
        search: searchText,
      },
    });

    if (status) {
      setState({
        ...state,
        rows: Array.isArray(data?.records) ? data.records : [],
      });
      // setTotalItems(data?.count || 0);
    }
    setLoading(false);
  };

  const fetchNotification = async () => {
    setLoading(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getNotificationReport,
      method: "GET",
      query: {
        search: searchText,
        page: currentPage,
        limit: itemsPerPage,
        ...filters,
      },
    });
    if (status) {
      setState({ ...state, rows: Array.isArray(data?.rows) ? data.rows : [] });
      setTotalItems(data?.totalCount || 0);
    }
    setLoading(false);
  };

  const getCategoryReport = async () => {
    setLoading(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getCategoryReport,
      method: "GET",
      query: {
        search: searchText,
        page: currentPage,
        limit: itemsPerPage,
      },
    });
    if (status) {
      setState({ ...state, rows: Array.isArray(data?.rows) ? data.rows : [] });
      setTotalItems(data?.totalCount || 0);
    }
    setLoading(false);
  };

  // Handler function
  const handleTabClick = (tabId) => {
    setState({ rows: [] });
    setSearchText("");
    setTotalItems(0);
    setCurrentPage(1); // Reset pagination
    setActiveTab(tabId); // Set the active tab
  };

  useEffect(() => {
    if (activeTab === "user") fetchUsers();
    if (activeTab === "revenue") fetchPurchaseStats();
    if (activeTab === "push") fetchNotification();
    if (activeTab === "category") getCategoryReport();
  }, [searchText, currentPage, activeTab]);

  return (
    <>
      <Row className="align-items-start">
        <Col md={8} className="py-1">
          <h4 className="dashheading">Manage Reports</h4>
          <p className="dashsubheading">Showing 1 to 10 of 57 list</p>
        </Col>
        <Col md={4} className="py-1">
          <div className="d-flex justify-content-end align-items-center gap-2">
            <CustomTextFeild
              style={{
                padding: " 7px 13px",
                borderRadius: "10px",
                height: "auto",
              }}
              icon={isDarkMode ? WhiteSearch : Search}
              iconHeight="15px"
              placeholder="Search"
              value={searchText}
              // onChange={(e) => setSearchText(e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value === "") {
                  setCurrentPage(1); // ✅ reset to first page on clear
                }
              }}
            />
            {/* <CustomButton
              variant="contained"
              text="Filter"
              iconLeft={<FilterAltRoundedIcon style={{ fontSize: 18 }} />}
              className="containebtn"
              onClick={() => setFilterModal(true)}
            /> */}
          </div>
        </Col>

        <Col md={12} className="mt-2">
          <div className="head-border" />
        </Col>

        <Col md={12} className="mt-3">
          <div className="d-flex flex-wrap gap-3">
            {tabs.map((tab) => (
              <CustomButton
                key={tab.id}
                text={tab.label}
                iconLeft={tab.icon}
                onClick={() => handleTabClick(tab.id)}
                variant={activeTab === tab.id ? "contained4" : "outline3"}
                style={{ padding: "9px 15px", borderRadius: "8px" }}
              />
            ))}
          </div>
        </Col>

        <Col md={12} className="mt-4 pb-2">
          {activeTab === "push" && (
            <>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : state.rows.length > 0 ? (
                <div className="table-responsive">
                  <table className="admintable">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Push Notice Title</th>
                        <th>Category</th>
                        <th>Location </th>
                        <th>Date Created</th>
                        <th>Date Published</th>
                        <th>Expiry Date</th>
                        <th>Status</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state?.rows?.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item?.notificationTitle || "----"}</td>
                          <td>{item?.categoryId?.categoryName || "----"}</td>
                          <td>{item?.address || "----"}</td>
                          <td>
                            {item?.createdAt
                              ? new Date(item.createdAt).toLocaleString()
                              : "----"}
                          </td>
                          <td>
                            {item?.startDate
                              ? new Date(item.startDate).toLocaleString()
                              : "----"}
                          </td>
                          <td>
                            {item?.endDate
                              ? new Date(item.endDate).toLocaleString()
                              : "----"}
                          </td>
                          <td>
                            {item?.startDate &&
                            new Date(item.startDate) > new Date()
                              ? "Upcoming"
                              : "Active"}
                          </td>

                          <td>{item?.user?.fullName || "----"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <p className="textwhite f-14 mb-0">
                      No Active Notification Found.
                    </p>
                  </td>
                </tr>
              )}
            </>
          )}

          {activeTab === "user" && (
            <>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : state.rows.length > 0 ? (
                <div className="table-responsive">
                  <table className="admintable">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>User ID</th>
                        <th>Email</th>
                        <th>Notifications Purchased</th>
                        <th>Notifications Used</th>
                        <th>Remaining Balance</th>
                        <th>Registration Date</th>
                        <th>Location</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state?.rows?.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item?.memberId || "----"}</td>
                          <td>{item?.email || "----"}</td>
                          <td>{item?.push_count_total || "----"}</td>
                          <td>{item?.push_count_used || "----"}</td>
                          <td>{item?.push_count || "----"}</td>
                          <td>
                            {item?.createdAt
                              ? new Date(item.createdAt).toLocaleString()
                              : "----"}
                          </td>
                          <td>{item?.address || "----"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <p className="textwhite f-14 mb-0">No users found.</p>
                  </td>
                </tr>
              )}
            </>
          )}

          {activeTab === "revenue" && (
            <>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : state.rows.length > 0 ? (
                <div className="table-responsive">
                  <table className="admintable">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Package Name</th>
                        <th>Package price</th>
                        <th>Number of Purchases</th>
                        <th>Total Revenue</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state?.rows?.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item?.packageName || "----"}</td>
                          <td>${item?.packagePrice || 0}</td>
                          <td>{item?.numberOfPurchases || "----"}</td>
                          <td>${item?.totalRevenue || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <p className="textwhite f-14 mb-0">
                      No Purchase Stats found.
                    </p>
                  </td>
                </tr>
              )}
            </>
          )}

          {activeTab === "category" && (
            <>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : state.rows.length > 0 ? (
                <div className="table-responsive">
                  <table className="admintable">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Category Name</th>
                        <th>Number of notifications</th>
                        {/* <th>Total Views</th> */}
                        <th>Total Subscribers </th>
                        {/* <th>Average CTR</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {state?.rows?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.categoryName || "----"}</td>
                          <td>{item?.notificationCount || "0"}</td>
                          {/* <td>45,000</td> */}
                          <td>{item?.subscriber || "0"}</td>
                          {/* <td>5.2%</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <p className="textwhite f-14 mb-0">
                      No Category Stats found.
                    </p>
                  </td>
                </tr>
              )}
            </>
          )}

          {/* {activeTab === "location" && (
            <div className="table-responsive">
              <table className="admintable">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Region / City</th>
                    <th>Active Users</th>
                    <th>Sent Notifications</th>
                    <th>Views / Clicks</th>
                    <th>Engagement Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>New York</td>
                      <td>12,500</td>
                      <td>9,800</td>
                      <td>6,400 / 1,250</td>
                      <td>13.2%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )} */}
        </Col>

        <Col md={12} className="text-end">
          <div className="d-flex justify-content-end">
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </Col>
      </Row>

      {/* Filter Modal ------------------------------ */}

      <CustomModal
        show={filterModal}
        onHide={() => {
          setFilterModal(false);
        }}
        title="List of Users"
        subtitle="Filter"
        showCloseButton={true}
        footerButtons={
          <>
            <div
              style={{
                display: "flex",
                marginTop: 10,
                justifyContent: "flex-start",
                gap: "10px",
                width: "100%",
              }}
            >
              <Button
                variant="secondary"
                style={{
                  backgroundColor: "rgba(75, 128, 235, 1)",
                  borderColor: "rgba(75, 128, 235, 1)",
                  padding: "8px 30px",
                  borderRadius: 10,
                }}
                onClick={() => {
                  setFilterModal(false);
                }}
              >
                Apply Filters
              </Button>
            </div>
          </>
        }
      >
        <Row className="mt-3">
          <Col md={12}>
            <p className="mb-1 input-label f-14">Select Country</p>
            <CustomSelect />
          </Col>
        </Row>
      </CustomModal>
    </>
  );
}
